import "./LandingPageParagraph.css";

const LandingPageParagraph = () => {
  return (
    <p className="paragraph landing-page__paragraph">
      Nie wierz nam na słowo - sprawdź
    </p>
  );
};
export default LandingPageParagraph;
